// @ts-nocheck
// TODO: tighten types after migration
import React from 'react';
import ProgressBorder from './ProgressBorder';
import './TapeLoader.css';

const TapeLoader = ({ progress = 0 }) => (
    <div className="fixed top-0 left-0 w-full h-full bg-white flex justify-center items-center z-[9999]">
        <div className="w-[200px] h-[120px] bg-light-gray-ccc rounded-[10px] relative shadow-[inset_0_-20px_0_#999] mx-auto my-auto">
            <ProgressBorder
                width={200}
                height={120}
                borderRadius={10}
                progress={progress}
            />
            <div className="absolute top-[40px] left-[30px] right-[30px] h-[40px] bg-black rounded-[8px] flex justify-between items-center px-5">
                <div className="tape-loader-reel"></div>
                <div className="tape-loader-reel"></div>
            </div>
        </div>
    </div>
);

export default TapeLoader;
